import { logUsage } from 'owa-analytics';
import { format } from 'owa-localize';
import { isBrowserChrome, isBrowserEdge, Browser } from 'owa-user-agent';

import {
    COMPATIBILITY_LEVEL_MAJOR,
    COMPATIBILITY_LEVEL_MINOR,
    SMIME_DEFAULT_EXTENSION_URL,
    SMIME_EDGE_EXTENSION_NAME,
    SMIME_EDGE_EXTENSION_URL,
    SMIME_CHROME_CONTROL_URL,
} from './constants';

/**
 * Utility function that forms the download url.
 */
export const getDownloadAddress = (url: string): string => {
    const version = format('{0}.{1}', COMPATIBILITY_LEVEL_MAJOR, COMPATIBILITY_LEVEL_MINOR);
    return format('{0}?v={1}', url, version);
};

/**
 * Utility function that downloads the plugin from url for Edge and IE browsers
 */
const downloadSmimeControl = () => {
    /**
     * Incase of Edge, opening the url using the window.open mutates the filename of the
     * downloaded extension. To ensure that it downloads with the same name we have created
     * a separate hidden anchor tag to achieve the same.
     */
    let browserType = Browser.UNKNOWN;
    if (isBrowserEdge()) {
        browserType = Browser.EDGE;
        const downloadUrl = getDownloadAddress(SMIME_EDGE_EXTENSION_URL);
        const anchorElement = <HTMLAnchorElement>document.createElement('a');
        anchorElement.href = downloadUrl;
        anchorElement.style.visibility = 'hidden';
        anchorElement.setAttribute('download', SMIME_EDGE_EXTENSION_NAME);
        document.body.appendChild(anchorElement);
        anchorElement.click();
        document.body.removeChild(anchorElement);
    } else if (isBrowserChrome()) {
        browserType = Browser.CHROME;
        window.open(getDownloadAddress(SMIME_CHROME_CONTROL_URL));
    } else {
        // Legacy extension for IE
        browserType = Browser.MSIE;
        window.open(getDownloadAddress(SMIME_DEFAULT_EXTENSION_URL));
    }
    logUsage('SmimeControlDownloadDatapoint', { browserType }, { isCore: true });
};

export default downloadSmimeControl;
